<div class="d-none d-lg-block" [formGroup]="formData">
  <table class="table w-100 table-striped">
    <thead>
      <tr>
        <th scope="col">{{ "CO-OWENERS_HEADER1" | globalTranslate }}</th>
        <th scope="col">{{ "CO-OWENERS_HEADER2" | globalTranslate }}</th>
        <th scope="col">{{ "CO-OWENERS_HEADER3" | globalTranslate }}</th>
        @if (jointOwnershipInformation.controls?.length >=2) {
        <th scope="col">
          <span class="sr-only">{{ "ACTION" | globalTranslate }}</span>
        </th>
        }
      </tr>
    </thead>
    <tbody formArrayName="jointOwnershipInformation">
      @for (row of jointOwnershipInformation.controls; track row; let i =
      $index; let isLast = $last) {
      <tr [formGroupName]="i">
        <td>
          @if (i == 0) {
          <nh-field
            [attr.aria-required]="true"
            [isRow]="true"
            [mandatory]="true"
          >
            <!-- <select nh name="jointOwnerIndividual" aria-label="jointOwnerIndividual" (change)="emitCoOwnerValidate(row, i)"
                [items]="coOwnerIndividuals" disabled formControlName="jointOwnerIndividual"
              ></select>
              <div *ngIf="coOwnerIndivErrorMessage && isLast" class="error-messages position-relative">
                <span class="form-text invalid-tooltip d-block">
                  <ng-container> {{coOwnerIndivErrorMessage | translate}}</ng-container>
                </span>
              </div> -->
            <input
              type="text"
              name="jointOwnerIndividual"
              [attr.aria-label]="'CO-OWENERS_TITLE' | globalTranslate"
              class="form-control"
              [value]="row?.value?.jointOwnerIndividual?.value"
              disabled
            />
          </nh-field>
          } @if (i != 0) {
          <nh-field
            [attr.aria-required]="true"
            [isRow]="true"
            [mandatory]="true"
          >
            <select
              nh
              name="jointOwnerIndividual"
              (change)="emitCoOwnerValidate(row, i)"
              [items]="coOwnerIndividuals"
              formControlName="jointOwnerIndividual"
              aria-required="true"
              [attr.aria-label]="'CO-OWENERS_TITLE' | globalTranslate"
            ></select>
            @if (coOwnerIndivErrorMessage && isLast) {
            <div class="error-messages position-relative" role="alert">
              <span class="form-text invalid-tooltip d-block">
                <ng-container>
                  {{ coOwnerIndivErrorMessage | globalTranslate }}</ng-container
                >
              </span>
            </div>
            }
          </nh-field>
          }
        </td>
        <td>
          <nh-field
            [attr.aria-required]="true"
            [isRow]="true"
            [mandatory]="true"
          >
            <input
              type="text"
              name="outOfHouseHoldname"
              aria-required="true"
              [attr.aria-label]="'CO-OWENERS_HEADER2' | globalTranslate"
              maxlength="35"
              class="form-control"
              formControlName="outOfHouseHoldname"
            />
          </nh-field>
        </td>
        <td>
          <nh-field
            [attr.aria-required]="true"
            [isRow]="true"
            [mandatory]="true"
          >
            <nh-input-group prepend="%">
              <input
                name="jointOwnerPercentage"
                aria-required="true"
                [attr.aria-label]="'CO-OWENERS_HEADER3' | globalTranslate"
                percentage="true"
                type="text"
                maxLength="3"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                class="form-control"
                (change)="emitErrorMessage(row)"
                formControlName="jointOwnerPercentage"
              />
            </nh-input-group>
            @if (formData.errors?.error && isLast && error.isError) {
            <div class="error-messages position-relative" role=" alert">
              <span class="form-text invalid-tooltip d-block">
                <ng-container>
                  {{ error.errorMessage | globalTranslate }}</ng-container
                >
              </span>
            </div>
            }
          </nh-field>
        </td>
        @if (jointOwnershipInformation.controls?.length >=2) {
        <td>
          @if (i) {
          <div class="pt-1 hover-red">
            <button
              class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
              (click)="removeIndex(i)"
            >
              <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
              <nh-remove-svg></nh-remove-svg>
            </button>
          </div>
          }
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
  <div class="pt-1 hover-red add-another-left">
    <button
      class="btn btn-link btn-lg hover-red"
      [disabled]="addRowValid"
      (click)="emitAdd()"
    >
      <span class="pe-2">{{ "ADD_2" | globalTranslate }}</span>
      <nh-add-svg></nh-add-svg>
    </button>
  </div>
</div>
<div class="nh-table-mobile mt-3 pt-2 d-lg-none" [formGroup]="formData">
  <div formArrayName="jointOwnershipInformation">
    @for (row of jointOwnershipInformation.controls; track row; let i = $index;
    let isLast = $last) {
    <div class="table-row mb-3 pb-3" [formGroupName]="i">
      <!-- <div class="tab-section" *ngIf="row?.value.jointOwnerIndividual !== null">{{'CO-OWENERS_STATIC_TEXT4' | translate }} {{
      row?.value?.jointOwnerIndividual?.value }}{{'CO-OWENERS_STATIC_TEXT5' | translate }}</div><hr> -->
      <div class="mobile-table-header">
        {{ "CO-OWENERS_HEADER1" | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">
        <nh-field [attr.aria-required]="true" [mandatory]="true">
          <select
            nh
            name="jointOwnerIndividual"
            (change)="emitCoOwnerValidate(row, i)"
            [items]="coOwnerIndividuals"
            formControlName="jointOwnerIndividual"
            aria-required="true"
            [attr.aria-label]="'CO-OWENERS_TITLE' | globalTranslate"
          ></select>
          @if (coOwnerIndivErrorMessage && isLast) {
          <div class="error-messages position-relative" role="alert">
            <span class="form-text invalid-tooltip d-block">
              <ng-container>
                {{ coOwnerIndivErrorMessage | globalTranslate }}</ng-container
              >
            </span>
          </div>
          }
        </nh-field>
      </div>
      <br />
      <div class="mobile-table-header">
        {{ "CO-OWENERS_HEADER2" | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">
        <nh-field [attr.aria-required]="true" [mandatory]="true">
          <input
            type="text"
            name="outOfHouseHoldname"
            aria-required="true"
            maxlength="35"
            class="form-control"
            formControlName="outOfHouseHoldname"
            [attr.aria-label]="'CO-OWENERS_HEADER3' | globalTranslate"
          />
        </nh-field>
      </div>
      <br />
      <div class="mobile-table-header">
        {{ "CO-OWENERS_HEADER3" | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">
        <nh-field [attr.aria-required]="true" [mandatory]="true">
          <nh-input-group prepend="%">
            <input
              name="jointOwnerPercentage"
              aria-required="true"
              percentage="true"
              type="text"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              class="form-control"
              (change)="emitErrorMessage(row)"
              [attr.aria-label]="'CO-OWENERS_HEADER3' | globalTranslate"
              formControlName="jointOwnerPercentage"
              maxlength="3"
            />
          </nh-input-group>
          @if (formData.errors?.error && isLast && error.isError) {
          <div class="error-messages position-relative">
            <span class="form-text invalid-tooltip d-block">
              <ng-container>
                {{ error.errorMessage | globalTranslate }}</ng-container
              >
            </span>
          </div>
          }
        </nh-field>
      </div>
      <br />
      @if (i) {
      <div class="pt-1 hover-red text-center">
        <button
          class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
          (click)="removeIndex(i)"
        >
          <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
          <nh-remove-svg></nh-remove-svg>
        </button>
      </div>
      }<br />
    </div>
    }
  </div>
  <div class="pt-1 hover-red add-another-left">
    <button
      class="btn btn-link btn-lg hover-red"
      [disabled]="addRowValid"
      (click)="emitAdd()"
    >
      <span class="pe-2">{{ "ADD_2" | globalTranslate }}</span>
      <nh-add-svg></nh-add-svg>
    </button>
  </div>
</div>